var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.5703 11.2554V67.3101C84.5703 68.146 84.2207 68.8999 83.6562 69.4331L42.2852 33.9253L84.0234 9.55225C84.3672 10.0308 84.5703 10.6206 84.5703 11.2554Z",
    fill: "#FF7733"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2852 33.9253L0.914062 69.4331C0.349609 68.8999 0 68.146 0 67.3101V11.2554C0 10.6206 0.203125 10.0308 0.546875 9.55225L42.2852 33.9253Z",
    fill: "#FFA64D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2852 33.9253L56.8359 52.7593L42.2852 70.2397H2.92969C2.14844 70.2397 1.4375 69.9331 0.914062 69.4331L34.6523 33.9253H42.2852Z",
    fill: "#FFC34D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6562 69.4331C83.1328 69.9331 82.4219 70.2397 81.6406 70.2397H42.2852V33.9253H49.918L83.6562 69.4331Z",
    fill: "#FFA64D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2852 8.32568L50 16.3335L42.2852 38.7105C41.6875 38.7105 41.0918 38.5288 40.582 38.1636L0.546875 9.55225C1.07812 8.81006 1.94727 8.32568 2.92969 8.32568H42.2852Z",
    fill: "#FFEA80"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0234 9.55225L43.9883 38.1636C43.4785 38.5288 42.8828 38.7105 42.2852 38.7105V8.32568H81.6406C82.623 8.32568 83.4922 8.81006 84.0234 9.55225Z",
    fill: "#FFC34D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9531 48.51L85.3531 67.3784L76.9531 88.7444C65.8418 88.7444 56.8359 79.7385 56.8359 68.6272C56.8359 57.5159 65.8418 48.51 76.9531 48.51Z",
    fill: "#E62E6B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0703 68.6272C97.0703 79.7385 88.0645 88.7444 76.9531 88.7444V48.51C88.0645 48.51 97.0703 57.5159 97.0703 68.6272Z",
    fill: "#B32453"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9531 57.2014L78.9682 62.3772L76.9531 69.3108C75.3359 69.3108 74.0234 67.9983 74.0234 66.3811V60.1311C74.0234 58.5139 75.3359 57.2014 76.9531 57.2014Z",
    fill: "#E6EEFF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9531 74.1956L78.1594 77.1252L76.9531 80.0549C75.3359 80.0549 74.0234 78.7424 74.0234 77.1252C74.0234 75.5061 75.3359 74.1956 76.9531 74.1956Z",
    fill: "#E6EEFF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9531 51.4397L80.5896 49.6625L76.9531 45.5803C64.2441 45.5803 53.9062 55.9182 53.9062 68.6272C53.9062 81.3362 64.2441 91.6741 76.9531 91.6741L80.5896 88.7444L76.9531 85.8147C67.4766 85.8147 59.7656 78.1038 59.7656 68.6272C59.7656 59.1506 67.4766 51.4397 76.9531 51.4397Z",
    fill: "#FF4D88"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M100 68.6272C100 81.3362 89.6621 91.6741 76.9531 91.6741V85.8147C86.4297 85.8147 94.1406 78.1038 94.1406 68.6272C94.1406 59.1506 86.4297 51.4397 76.9531 51.4397V45.5803C89.6621 45.5803 100 55.9182 100 68.6272Z",
    fill: "#E62E6B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8828 77.1252C79.8828 78.7424 78.5703 80.0549 76.9531 80.0549V74.1956C78.5703 74.1956 79.8828 75.5061 79.8828 77.1252Z",
    fill: "#CCDDFF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8828 60.1311V66.3811C79.8828 67.9983 78.5703 69.3108 76.9531 69.3108V57.2014C78.5703 57.2014 79.8828 58.5139 79.8828 60.1311Z",
    fill: "#CCDDFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/not_found.18c8a56290d2d1202acba3142e50fa96.svg";
export { ForwardRef as ReactComponent };